<template>
  <el-dialog
    :title="DialogTitle"
    :visible.sync="dialogVisible"
    width="1000px"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :before-close="handleClose"
    :append-to-body="true"
  >
    <template v-if="type === 'time'">
      <ming-table v-model="courseTimeDialogTableData" :fields="column" max-height="400px">
        <template #date="{ scope }"> {{ scope.day }}{{ scope.week ? `（${scope.week}）` : '' }}</template>
      </ming-table>
    </template>
    <template v-if="type === 'courseTime'">
      <ming-table v-model="courseTimeDialogTableData" :fields="courseTime" max-height="400px">
        <template #date="{ scope }"> {{ scope.day }}{{ scope.week ? `（${scope.week}）` : '' }}</template>
      </ming-table>
    </template>
    <!-- courseTime -->
    <ming-table v-if="type === 'down' && courseTimeDialogFileData" v-model="courseTimeDialogFileData" max-height="400px" :fields="handoutDown">
      <template #options="{ scope }">
        <el-link type="primary" :href="scope.path" target="_blank">下载</el-link>
      </template>
    </ming-table>

    <template v-if="['stop', 'extra'].includes(type)">
      <ming-table v-model="courseTimeDialogTableData" max-height="400px" :fields="stopReasonColumn">
        <template #time="{ scope }"> {{ scope.startTime }} - {{ scope.endTime }} </template>
      </ming-table>
    </template>
    <template v-if="type === 'change'">
      <ming-table v-model="courseTimeDialogTableData" max-height="400px" :fields="changeReasonColumn">
        <template #time="{ scope }"> {{ scope.startTime }} - {{ scope.endTime }} </template>
        <template #oldInfo="{ scope }">
          <div class="change-old-info">
            <div>
              <span>授课时间：</span>
              <span>{{ scope.oldInfo.classDate }}</span>
            </div>
            <div>
              <span>授课老师：</span>
              <span>{{ scope.oldInfo.teacher }}</span>
            </div>
            <div>
              <span>地点：</span>
              <span>{{ scope.oldInfo.address }}</span>
            </div>
          </div>
        </template>
      </ming-table>
    </template>
    <template v-if="type === 'teacher'">
      <ming-table v-model="teacherData2" :fields="teacherColumn" max-height="400px">
        <template #date="{ scope }"> {{ scope.day }}（{{ scope.week }}） </template>
      </ming-table>
    </template>
  </el-dialog>
</template>

<script setup>
import { computed, ref, onMounted } from 'vue'
import { CourseHook } from '@/hooks/courseHook'
const { courseTimeDialogTableData, getCourseTime, getCourseInfoAndFile, getStopCourseReason, getChangeCourse, showExtraCourse } = CourseHook()

const emit = defineEmits(['handleClose'])

const teacherData2 = ref([])

const teacherColumn = ref([
  {
    label: '姓名',
    field: 'name'
  },
  {
    label: '电话',
    field: 'mobile'
  },
  {
    label: '邮箱',
    field: 'email'
  }
])

const column = ref([
  {
    label: '上课日期',
    field: 'date',
    slot: true
  },
  {
    label: '上课开始时间',
    field: 'start_time'
  },
  {
    label: '上课结束时间',
    field: 'end_time'
  },
  {
    label: '上课地点',
    field: 'address'
  },
  {
    label: '授课老师',
    field: 'teacher'
  }
])
const courseTime = ref([
  {
    label: '上课日期',
    field: 'date',
    slot: true
  },
  {
    label: '上课开始时间',
    field: 'start_time'
  },
  {
    label: '上课结束时间',
    field: 'end_time'
  },
  {
    label: '上课地点',
    field: 'address'
  }
])

const handoutDown = ref([
  {
    label: '讲义',
    field: 'name'
  },
  // {
  //   label: '类型',
  //   field: 'type'
  // },
  {
    label: '操作',
    field: 'options',
    slot: true
  }
])

const stopReasonColumn = ref([
  {
    label: '上课日期',
    field: 'classDate'
  },
  {
    label: '上课时间',
    field: 'time',
    slot: true
  },
  {
    label: props.type === 'stop' ? '停课原因' : '补课原因',
    field: 'reason'
  }
])
const changeReasonColumn = ref([
  {
    label: '上课日期',
    field: 'classDate',
    fixed: 'left'
  },
  {
    label: '上课时间',
    field: 'time',
    slot: true
  },
  {
    label: '授课老师',
    field: 'teacher'
  },
  {
    label: '上课地点',
    field: 'address'
  },
  {
    label: '原上课安排',
    field: 'oldInfo',
    slot: true,
    width: '200px'
  },
  {
    label: '调课原因',
    field: 'reason'
  }
])

const props = defineProps({
  visible: {
    type: Boolean,
    default: () => false
  },
  type: {
    type: String,
    default: () => ''
  },
  courseId: {
    type: [Number, String],
    default: () => ''
  },
  teacherData: {
    type: Array,
    default: () => []
  },
  courseTimeDialogFileData: {
    type: Array,
    default: () => []
  }
})

const courseTimeDialogFileData = computed(() => {
  return props.courseTimeDialogFileData
})

const DialogTitle = computed(() => {
  let title = ''
  switch (props.type) {
    //
    case 'time':
    case 'courseTime':
      title = '查看上课时间'
      break
    case 'down':
      title = '课程资料'
      break
    case 'stop':
      title = '停课及原因'
      break
    case 'extra':
      title = '补课及原因'
      break
    case 'change':
      title = '调课及原因'
      break
    case 'teacher':
      title = '任课老师'
      break
  }
  return title
})

const dialogVisible = computed(() => {
  return props.visible
})
const courseId = computed(() => {
  return props.courseId
})
const type = computed(() => {
  return props.type
})

function handleClose() {
  emit('update:visible', false)
}

onMounted(() => {
  switch (type.value) {
    case 'courseTime':
    case 'time':
      getCourseTime(courseId.value)
      break
    case 'down':
      getCourseInfoAndFile(courseId.value)
      break
    case 'stop':
      getStopCourseReason(courseId.value)
      break
    case 'change':
      getChangeCourse(courseId.value)
      break
    case 'extra':
      showExtraCourse(courseId.value)
      break
    case 'teacher':
      teacherData2.value = props.teacherData
      break
    default:
      break
  }
})
</script>

<style lang="scss" scoped>
.change-old-info {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  text-align: left;
}
</style>
